<div id="map-container">
    <div #container id="cy"></div>

    @if (!data?.nodes?.length) {
        <div class="vertical-centering">
            <i class="fas fa-info-circle default-icon-color fa-7x"></i>
            <div class="no-records-message">{{ 'devices.hints.notFound' | translation | async }}</div>
            <div class="no-records-message-detail">{{ 'devices.noMapData' | translation | async }}</div>
        </div>
    }

    <ngx-ui-loader loader [loaderId]="loaderId"></ngx-ui-loader>
</div>
